export default __webpack_public_path__ + "static/media/Ellipse 26.141782f1.png";